import { createSlice } from "@reduxjs/toolkit";

const initialState = {
    staffId: '',
    userId: '',
    email: '',
    domainName: '',
    sellerId: '',
    name: '',
    authToken: {},
    permissions: [],
    platform: '',
    profilePicture: '',
    shop_name: ''
}

export const staffSlice = createSlice({
    name: 'staffInfo',
    initialState,
    reducers: {
        setStaffInfo: (state, action) => {
            console.log(action.payload)
            const { payload } = action;
            if (payload) {
                state.staffId = payload.staffId || state.staffId;
                state.userId = payload.userId || state.userId;
                state.name = payload.name || state.name;
                state.email = payload.email || state.email;
                state.domainName = payload.domainName || state.domainName;
                state.sellerId = payload.sellerId || state.sellerId;
                state.authToken = payload.authToken || state.authToken
                state.plan = payload.plan || state.plan;
                state.permissions = payload.permissions || state.permissions;
                state.platform = payload.platform || state.platform;
                state.profilePicture = payload.profilePicture || state.profilePicture;
                state.shop_name = payload.shop_name || state.shop_name;
            }
        },
        deleteStaffInfo: (state, action) => {
            state.staffId = ''
            state.userId = ''
            state.email = ''
            state.domainName = ''
            state.sellerId = ''
            state.name = ''
            state.authToken = {}
            state.plan = {},
            state.permissions = []
            state.platform = ''
            state.shop_name =''
        }
    }
})

export const { setStaffInfo, deleteStaffInfo } = staffSlice.actions

export default staffSlice.reducer